export default __webpack_public_path__ + "static/illustration-dont-3071c70cc684bc8f31a3766ffc3d77410ffe538efb257574aa0bc32881ff3899.png";